export function getDateWithQuarterHourTimeAfterOffset(date: Date, offsetMinutes: number): Date {
  if (!Number.isFinite(offsetMinutes) || offsetMinutes < 0) {
    throw new Error('Offset must be a non-negative number');
  }

  const roundedMinutes = Math.floor(date.getMinutes() / 15) * 15;
  const minimumTime = new Date(date);
  minimumTime.setMinutes(roundedMinutes + offsetMinutes, 0, 0);
  return minimumTime;
}
